/** Cesta → id sekce pro scroll na one-page layout */
export const ROUTE_TO_SECTION: Record<string, string> = {
  '/': 'hero',
  '/about': 'about',
  '/education': 'education',
  '/projects': 'projects',
  '/web-dev': 'web-dev',
  '/skills': 'skills',
  '/hackathons': 'hackathons',
  '/contact': 'contact',
};

export const SITE_PATHS = Object.keys(ROUTE_TO_SECTION);

export function pathToSectionId(pathname: string): string {
  const normalized = pathname.endsWith('/') && pathname.length > 1
    ? pathname.slice(0, -1)
    : pathname;
  return ROUTE_TO_SECTION[normalized] ?? 'hero';
}
